//@import dependencies
import React, {Component} from 'react'
//@end

//@import components
import {Error404ScreenLayout} from 'app_components/screens/errors/404'
//@end

// @ADD Component types
interface IError404ScreenProps {}
interface IError404ScreenState {}

class Error404Screen extends Component<IError404ScreenProps, IError404ScreenState> {
  render() {
    return(
      <Error404ScreenLayout />
    )
  }
}

export default Error404Screen
